import * as React from 'react';
import * as styles from './Description.css';

interface IDescriptionProps {
  html: string;
}

export const Description: React.FC<IDescriptionProps> = ({ html }) => {
  // oxlint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html as string }} className={styles['markup']} />;
};
